module.exports = __webpack_public_path__ + "media/luxury-2026/kingdom-living-960-40b581ff.jpg";